<div class="rounded-corners">
  <table mat-table [dataSource]="tableData" cdkDropList cdkDropListOrientation="horizontal" multiTemplateDataRows>
    <!-- Loop columnsToDisplay array -->
    @for (column of displayedColumns; track column) {
      <ng-container [matColumnDef]="column.columnName">
        <!-- HEADER -->
        @if (column.columnName !== 'actions') {
          <th mat-header-cell cdkDrag *matHeaderCellDef translate="Table.{{column.transTag}}"
          class="col-{{column.noOfColumns}}"></th>
        }
        @if (column.columnName === 'actions') {
          <th mat-header-cell cdkDrag *matHeaderCellDef class="col-1"></th>
        }
        <!-- BODY -->
        @if (column.columnName !== 'deadline' && column.columnName !== 'actions') {
          <td mat-cell *matCellDef="let actor" class="col-{{column.noOfColumns}}" [ngClass]="{'text-muted': isWaiting(actor.actorStatus)}">
            @if (column.columnName === 'fullName') {
              <app-badge-status-display [badgeStatus]="convertedStatusToBadgeStatus(actor.actorStatus)"
              class="badge-status-table"></app-badge-status-display>
            }
            {{ actor[column.columnName] | valueByTypePipe : column.type }}
          </td>
        }
        @if (column.columnName === 'deadline') {
          <td mat-cell *matCellDef="let actor" class="col-{{column.noOfColumns }}" [ngClass]="{'text-muted': isWaiting(actor.actorStatus)}">
            <app-deadline [deadline]="actor.deadline" [dateSigned]="actor.dateSigned" [deadlineDays]="actor.deadlineDays"></app-deadline>
          </td>
        }
        @if (column.columnName === 'actions') {
          <td mat-cell *matCellDef="let actor" class="col-{{column.noOfColumns}}">
            <span class="float-end">test
              <button type="button" class="btn bg-transparent border-0" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi bi-three-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(requestStatusActionsEnum.resendRequest, actor)"
                    id="sendReminderButton" [ngClass]="{ 'disabled': !actor.allowedToResendInvite }"
                  translate="Request.Actions.SendReminder"></a>
                </li>
                <li>
                  <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(requestStatusActionsEnum.editPerson, actor)"
                    id="editPersonButton" [ngClass]="{ 'disabled': !actor.allowedToEdit }"
                    translate="Request.Actions.EditPerson">
                  </a>
                </li>
                @if (actor.allowedToChangeDeadline) {
                  <li>
                    <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(requestStatusActionsEnum.changeDeadline, actor)"
                      Id="changeDeadlineButton" translate="Request.Actions.ChangeDeadline">
                    </a>
                  </li>
                }
                @if (!actor.allowedToChangeDeadline) {
                  <li>
                    <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(requestStatusActionsEnum.changeDeadlineDays, actor)"
                      [ngClass]="{ 'disabled': !actor.allowedToChangeDeadlineDays}"
                      translate="Request.Actions.ChangeDeadlineDays" Id="changeDeadlineDaysButton">
                    </a>
                  </li>
                }
                @if (!actor.completionDate && actor.action === actionEnum.Sign) {
                  <li>
                    <a class="dropdown-item pt-1 pb-1" (click)="performActionForAnId(requestStatusActionsEnum.changeSignatureProvider, actor)"
                      [ngClass]="{ 'disabled': !actor.allowedToChangeSignatureProvider}"
                      translate="Request.Actions.ChangeSignatureProvider" Id="changeSignatureProviderButton">
                    </a>
                  </li>
                }
              </ul>
            </span>
          </td>
        }
      </ng-container>
    }

    <ng-container matColumnDef="message">
      <td *matCellDef="let error" mat-cell [attr.colspan]="displayedColumns.length">
        <div class="break-words">
          <div class="alert alert-danger p-1 mt-0 white-space" role="alert">
            {{error.declineMessage}}
          </div>
        </div>
      </td>
    </ng-container>

    <!-- Display data and declare specific embedded component -->
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    <tr mat-row *matRowDef="let row; columns: ['message']; when: hasDeclineMessage"></tr>
  </table>
</div>